module.exports = __webpack_public_path__ + "img/sensor-on.404cc0aa.svg";